import React from "react";
import { ServicesFooter } from "./services-footer"


/**
 * Componente para mostrar el servicio Crecimiento Exponencial.
 *
 * @component
 * 
 */

export const CrecimientoExponencial = (props) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const breakpoint = 620;

    React.useEffect(() => {
        /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
        window.addEventListener("resize", () => setWidth(window.innerWidth));

        /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    }, []);
    
  return (
    <div id="service-detail" className="text-center">
        <div className="col-md-8 col-xs-12 col-md-offset-2 section-title">
            <h2><span className="title">Servicios</span></h2>
        </div>
        <div className="col-md-12 col-xs-12 imgMain paddingRightLeft0 text-right">
            <img alt="Crecimiento Exponencial" src={width < breakpoint ? "/img/services/CrecimientoExpo/CrecimientoExpo_img1_mob.webp" : "/img/services/CrecimientoExpo/CrecimientoExpo_img1.webp"}></img>
            <div className="text-left titleService">
                <p>Crecimiento <br></br>Exponencial</p>
            </div>
        </div>
        <div className="container-fluid padding-fluid">
            <div className="row">
                <div className="col-md-12 col-xs-12">
                    <div className="col-md-1">&nbsp;</div>
                </div>
                <div className="col-md-12 col-xs-12">
                    <div className="col-md-12 col-xs-12">
                        <div className={width < breakpoint ? "col-md-8 text-left text-analisisdato-1 paddingRightLeft0" : "col-md-8 text-left text-analisisdato-1"}>
                            <p><br></br>Con un enfoque centrado en el rendimiento digital, nos aseguramos de optimizar cada aspecto de las estrategias para tu marca, desde la adquisición de clientes hasta la retención y el aumento de ingresos.<br></br>&nbsp;</p>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 col-xs-12">
                    <div className="col-md-1">&nbsp;</div>
                </div>
                {width < breakpoint ?
                <div className="col-xs-10 col-xs-offset-2 paddingRightLeft0">
                    <img alt="Crecimiento Exponencial" src="/img/services/CrecimientoExpo/CrecimientoExpo_img2.webp"></img>
                </div>
                : ''}
                {width < breakpoint ?
                    <div className="col-md-12 col-xs-12">
                        <div className="col-md-12 col-xs-12">
                            <div className="col-md-12 col-xs-12">
                                
                                <div className="col-md-3 col-xs-10 col-xs-offset-1 text-right text-analisisdato-img2 flex-text-end">
                                    <span>A través de tácticas impulsadas por datos y herramientas de análisis avanzadas, maximizamos el retorno de la inversión, definimos mejoras en cada etapa del embudo de ventas y potenciamos el crecimiento sostenible, impulsando resultados excepcionales para nuestros clientes.</span>
                                </div>
                            </div>
                            <div className={width < breakpoint ? "col-md-12 col-xs-12 paddingTopBottom16 paddingRightLeft0" : "col-md-12 col-xs-12 paddingTopBottom16"}>
                                <div className="col-md-3"></div>
                                <div className={width < breakpoint ? "col-md-9 paddingTopBottom16 text-left text-analisisdato-1 paddingRightLeft0" : "col-md-9 paddingTopBottom16 text-left text-analisisdato-1"}>
                                    <p>Aplicamos técnicas de optimización de motores de búsqueda SEO y SEM, para aumentar la visibilidad y la atracción de tráfico relevante. Implementamos estrategias de marketing de contenido de alta calidad y creamos campañas de marketing personalizadas para nutrir y convertir clientes potenciales.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                :
                    <div className="col-md-12 col-xs-12">
                        <div className="col-md-12 col-xs-12">
                            <div className="col-md-12 col-xs-12 flex">
                                <div className="col-md-3 col-xs-12 text-right text-analisisdato-img2 flex-text-end">
                                    <span>A través de tácticas impulsadas por datos y herramientas de análisis avanzadas, maximizamos el retorno de la inversión, definimos mejoras en cada etapa del embudo de ventas y potenciamos el crecimiento sostenible, impulsando resultados excepcionales para nuestros clientes.</span>
                                </div>
                                <div className="col-md-9 col-xs-12">
                                    <img alt="Crecimiento Exponencial" src="/img/services/CrecimientoExpo/CrecimientoExpo_img2.webp"></img>
                                </div>
                            </div>
                            <div className="col-md-12 paddingTopBottom16">
                                <div className="col-md-3"></div>
                                <div className="col-md-9 paddingTopBottom16 text-left text-analisisdato-1">
                                    <p><br></br>Aplicamos técnicas de optimización de motores de búsqueda SEO y SEM, para aumentar la visibilidad y la atracción de tráfico relevante. Implementamos estrategias de marketing de contenido de alta calidad y creamos campañas de marketing personalizadas para nutrir y convertir clientes potenciales.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        {width < breakpoint ?
        <div>
            <img alt="Buyer Persona" src="/img/services/CrecimientoExpo/CrecimientoExpo_img3_mob.webp"></img>
            <div className="col-md-12 col-xs-12 paddingRightLeft0">
                <div className="col-md-12 col-xs-12 text-2 paddingRightLeft0">
                    <div className="col-md-6 col-xs-10 text-2 col-xs-offset-1 paddingRightLeft0">
                        <p>Combinamos análisis de datos avanzados, estrategias efectivas, optimización continua y una mentalidad orientada a resultados para generar un impacto medible en tu negocio.</p>
                    </div>
                </div>
            </div>
        </div>
        :
        <div>
            <div className="col-md-12 col-xs-12 padding paddingRightLeft0">
                <div className="col-md-12 col-xs-12 background paddingRightLeft0" style={{ background: "url('../img/services/CrecimientoExpo/CrecimientoExpo_img3.webp')", backgroundSize: 'cover' }}>
                    <div className="col-md-6 text-2 paddingRightLeft0">
                        <p>Combinamos análisis de datos avanzados, estrategias efectivas, optimización continua y una mentalidad orientada a resultados para generar un impacto medible en tu negocio.</p>
                    </div>
                </div>
            </div>
        </div>}
        {width < breakpoint ? <div style={{ paddingBottom: '64px' }}></div> :
            <div>
                <div className="paddingTopBottom16">
                    &nbsp;
                </div>
                <div className="container-fluid padding-fluid">
                    <div className="row">
                        <ServicesFooter data={props.data} id={3} />
                    </div>
                </div>
            </div>
        }
    </div>
  );
};
